import React from 'react';
import './styles.scoped.css';

const resolveIcon = icon => {
  try {
    return require(`../../assets/${icon}.png`);
  } catch {
    // icon name comes from runtime Application data; a build without the
    // matching brand asset must not crash the dashboard
    return null;
  }
};

const MenuItem = ({ icon, text, onPress, description }) => {
  const iconSrc = resolveIcon(icon);
  const words = text.split(' ');
  const formattedText = words.flatMap((word, index) =>
    word === 'Edge'
      ? [
          <span style={{ fontStyle: 'italic' }} key={index}>
            {word.toUpperCase()}
          </span>,
          ' ',
        ]
      : [word, ' '],
  );

  return (
    <div className="menu-item" onClick={onPress}>
      {iconSrc && <img alt="" className="icon" height={60} width={60} src={iconSrc} />}
      <div className="text-wrapper">
        <span className="title-text">{formattedText}</span>
        {description && <span className="description-text">{description}</span>}
      </div>
    </div>
  );
};

export default MenuItem;
